import React from "react";
import ReactModal from "react-modal";
import { HookForm } from "../../../../validation/HForm";
import serviceInformationScheme from "../../../../validation/scheme/serviceInformationScheme";
import ServiceInformationAdd from "./ServiceInformationAdd";
import Message from "../../Message/Message";
import CrossIcon from "../../../../assets/icons/cross.svg";
import { MODAL_NAME } from "./constants";

const ServiceInformationModal = ({ state, clientId, changeModalState, description, aimAndRelationshipFeature, handleAdditionalChange, onSubmit }) => {

  const handleSubmitInformation = (data, listName) => onSubmit(data, listName, MODAL_NAME);
  const handleCloseModal = () => changeModalState(MODAL_NAME, false);

  const buttonText = isNaN(state.tempEntity.index) ? "Добавить" : "Сохранить";
  const titleText = isNaN(state.tempEntity.index) ? 'Добавить служебную информацию' : 'Редактировать служебную информацию';
  const isButtonDisabled = !!state.commonError;

  return (
    <ReactModal
      isOpen={state[MODAL_NAME]}
      contentLabel="Modal"
      className="modal-container visible-modal"
      overlayClassName="modal-overlay"
    >
      <HookForm
        onSubmit={(entity) =>
          handleSubmitInformation(entity, "serviceInformation")
        }
        validationSchema={serviceInformationScheme(aimAndRelationshipFeature)}
        defaultValues={state.tempEntity}
      >
        <div className="modal-header">
          <h2>{titleText}</h2>
          <button
            className="button-icontrigger modal-closetrigger"
            onClick={handleCloseModal}
          >
            <span className="icon">
              <CrossIcon />
            </span>
          </button>
        </div>

        {state.commonError && (
          <div className="p-l-spacer-2 p-r-spacer-2">
            <Message type="error" text={state.commonError} />
          </div>
        )}

        <div className="modal-body">
          <ServiceInformationAdd 
            h="true" 
            tempEntity={state.tempEntity} 
            clientId={clientId} 
            description={description} 
            handleAdditionalChange={handleAdditionalChange}/>
        </div>

        <div className="modal-footer">
          <button
            className={
              isButtonDisabled ? "button-icontrigger-disabled" : "button"
            }
            disabled={isButtonDisabled}
          >
            {buttonText}
          </button>
          <button className="button-light" onClick={handleCloseModal}>
            Отменить
          </button>
        </div>
      </HookForm>
    </ReactModal>
  );
};

export default ServiceInformationModal;
